export const Button = ({ children, onClick, active, disabled, pending, className = '' }) => {
  return (
    <button
      onClick={onClick}
      disabled={disabled || pending}
      className={`relative flex items-center justify-center rounded-lg px-4 py-2 font-medium transition-all hover:shadow-md ${
        active
          ? 'bg-accent-400 text-accent-100 hover:bg-accent-500'
          : 'text-grey-700 border-[1px] border-b-0 border-r-0 border-white/30 bg-white/50 shadow'
      } ${disabled ? 'cursor-not-allowed opacity-50' : ''} ${className} `}
    >
      <span className={pending ? 'invisible' : 'visible'}>{children}</span>
      {pending && (
        <div className="absolute inset-0 flex items-center justify-center">
          <svg
            className="h-5 w-5 animate-spin text-current"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
          >
            <circle
              className="opacity-25"
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              strokeWidth="4"
            ></circle>
            <path
              className="opacity-75"
              fill="currentColor"
              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
            ></path>
          </svg>
        </div>
      )}
    </button>
  )
}
